var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02748 0.25H14.7674C16.864 0.25 18.5449 1.87504 18.5449 3.85714V14.1429C18.5449 16.125 16.864 17.75 14.7674 17.75H4.02748C1.93094 17.75 0.25 16.125 0.25 14.1429V3.85714C0.25 1.87504 1.93094 0.25 4.02748 0.25Z",
    fill: "url(#paint0_radial_4833_174)",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02748 0.25H14.7674C16.864 0.25 18.5449 1.87504 18.5449 3.85714V14.1429C18.5449 16.125 16.864 17.75 14.7674 17.75H4.02748C1.93094 17.75 0.25 16.125 0.25 14.1429V3.85714C0.25 1.87504 1.93094 0.25 4.02748 0.25Z",
    fill: "url(#paint1_radial_4833_174)",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02748 0.25H14.7674C16.864 0.25 18.5449 1.87504 18.5449 3.85714V14.1429C18.5449 16.125 16.864 17.75 14.7674 17.75H4.02748C1.93094 17.75 0.25 16.125 0.25 14.1429V3.85714C0.25 1.87504 1.93094 0.25 4.02748 0.25Z",
    fill: "url(#paint2_radial_4833_174)",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8463 5.4638C13.8463 5.8482 13.5177 6.17808 13.0894 6.17808C12.6611 6.17808 12.3325 5.8482 12.3325 5.4638C12.3325 5.07938 12.6611 4.74951 13.0894 4.74951C13.5177 4.74951 13.8463 5.07938 13.8463 5.4638Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5037 8.99847C12.5037 10.6255 11.1233 11.9628 9.39749 11.9628C7.67169 11.9628 6.29126 10.6255 6.29126 8.99847C6.29126 7.37142 7.67169 6.03418 9.39749 6.03418C11.1233 6.03418 12.5037 7.37142 12.5037 8.99847ZM9.39749 11.177C10.6375 11.177 11.6612 10.2118 11.6612 8.99847C11.6612 7.78517 10.6375 6.81989 9.39749 6.81989C8.15752 6.81989 7.13375 7.78517 7.13375 8.99847C7.13375 10.2118 8.15752 11.177 9.39749 11.177Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34473 4.79475L3.34474 4.79475C3.70541 4.11682 4.28202 3.56367 4.99374 3.21637L4.99374 3.21637C5.38435 3.02576 5.84632 2.92448 6.50329 2.87308C7.16286 2.82147 7.99728 2.82129 9.12903 2.82129H9.66602C10.7978 2.82129 11.6322 2.82147 12.2918 2.87308C12.9487 2.92448 13.4107 3.02576 13.8013 3.21637L13.8013 3.21637C14.513 3.56367 15.0896 4.11682 15.4503 4.79474L15.4503 4.79476C15.6474 5.16524 15.7525 5.60376 15.806 6.2306C15.8598 6.8607 15.86 7.65832 15.86 8.74272V9.257C15.86 10.3414 15.8598 11.139 15.806 11.7691C15.7525 12.396 15.6474 12.8345 15.4503 13.2049L15.4503 13.205C15.0896 13.8829 14.513 14.4361 13.8013 14.7833L13.8013 14.7833C13.4107 14.974 12.9487 15.0752 12.2918 15.1266C11.6322 15.1783 10.7978 15.1784 9.66602 15.1784H9.12903C7.99728 15.1784 7.16286 15.1783 6.50329 15.1266C5.84633 15.0752 5.38435 14.974 4.99375 14.7833L4.99373 14.7833C4.28202 14.4361 3.70541 13.8829 3.34474 13.2049L3.34473 13.2049C3.14762 12.8345 3.0425 12.396 2.98902 11.7691C2.93527 11.139 2.93506 10.3414 2.93506 9.257V8.74272C2.93506 7.65832 2.93527 6.8607 2.98902 6.2306C3.0425 5.60375 3.14762 5.16523 3.34473 4.79475ZM13.4111 3.9126L13.4111 3.91259C13.161 3.79051 12.8246 3.70323 12.2214 3.65604C11.6051 3.60783 10.8119 3.607 9.66602 3.607H9.12903C7.9831 3.607 7.18992 3.60783 6.57362 3.65604L6.59312 3.90528L6.57362 3.65604C5.97049 3.70323 5.63409 3.79051 5.38392 3.91259L5.38391 3.9126C4.83262 4.18163 4.38237 4.61192 4.09949 5.14357L4.09949 5.14358C3.97009 5.38679 3.87834 5.71288 3.82887 6.29282L4.07796 6.31407L3.82887 6.29282C3.77838 6.88463 3.77755 7.6458 3.77755 8.74272V9.257C3.77755 10.3539 3.77838 11.1151 3.82887 11.7069C3.87834 12.2868 3.97009 12.6129 4.09949 12.8561L4.09949 12.8561C4.38237 13.3878 4.83263 13.8181 5.38391 14.0871C5.63408 14.2092 5.97048 14.2965 6.57363 14.3437C7.18992 14.3919 7.98309 14.3927 9.12903 14.3927H9.66602C10.812 14.3927 11.6051 14.3919 12.2214 14.3437C12.8246 14.2965 13.161 14.2092 13.4111 14.0871C13.9624 13.8181 14.4127 13.3878 14.6955 12.8562C14.8249 12.6129 14.9167 12.2869 14.9662 11.7069C15.0166 11.1151 15.0175 10.3539 15.0175 9.257V8.74272C15.0175 7.64578 15.0166 6.88464 14.9662 6.29283L14.7171 6.31407L14.9662 6.29283C14.9167 5.71287 14.8249 5.38677 14.6955 5.14357C14.4127 4.61192 13.9624 4.18163 13.4111 3.9126Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4833_174",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.71247 13.5) rotate(-54.2095) scale(16.6428 16.8857)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4833_174",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.04122 18.6429) rotate(-64.1786) scale(14.6403 15.0467)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4833_174",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.00687 0.642857) rotate(-7.79056) scale(26.0838 5.35195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f20dce01a2d71693b65e4b8c34a66c05.svg";
export { ForwardRef as ReactComponent };